export default __webpack_public_path__ + "static/media/avatar_37.2b696b1a.png";